import type { ErrCode, GMOTokenObject, GMOTokenResponse } from '~/types/gmo'
import { ErrMessage } from '~/types/gmo'

/**
 * GMOから新規カード登録し、決済するためのカードトークンを取得する
 */
export const getGMOCardToken = (
  apiKey: string,
  cardNumber: string,
  cardYM: string,
  securityCode: string,
  holderName: string
): Promise<GMOTokenObject> => {
  window.Multipayment.init(apiKey)
  return new Promise((resolve, reject) => {
    window.Multipayment.getToken(
      { cardno: cardNumber, expire: cardYM, securitycode: securityCode, holdername: holderName },
      (response: GMOTokenResponse) => {
        if (response.resultCode !== '000') {
          reject(getTokenError(response.resultCode))
        } else {
          resolve({
            token: response.tokenObject.token,
            maskedCardNo: response.tokenObject.maskedCardNo,
          })
        }
      }
    )
  })
}

const getTokenError = (errCode: ErrCode): string => {
  return ErrMessage[errCode]
}
